import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthContext.js";
import { rutaInicioPorRol } from "../../auth/roles.js";
import { AdultScreen, Content } from "../../components/Layout.js";
import { Card } from "../../components/Card.js";
import { Button } from "../../components/Button.js";
import { Field, TextInput, Select, ErrorBanner } from "../../components/Form.js";
import { useT } from "../../i18n/index.js";
import { mensajeDeError } from "../../hooks/useQuery.js";

export function RegisterPage() {
  const t = useT();
  const { registrar } = useAuth();
  const navigate = useNavigate();
  const [nombre, setNombre] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rol, setRol] = useState<"padre" | "terapeuta">("padre");
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);

  async function onSubmit(ev: FormEvent) {
    ev.preventDefault();
    setError(null);
    setEnviando(true);
    try {
      const usuario = await registrar({ nombre, email, password, rol });
      navigate(rutaInicioPorRol(usuario.rol), { replace: true });
    } catch (e) {
      setError(mensajeDeError(e));
    } finally {
      setEnviando(false);
    }
  }

  return (
    <AdultScreen>
      <Content>
        <h1 style={{ fontSize: 24, marginTop: 16 }}>{t("auth.register.title")}</h1>
        <Card>
          <form onSubmit={onSubmit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            {error ? <ErrorBanner message={error} /> : null}
            <Field label={t("auth.register.name")}>
              <TextInput required value={nombre} onChange={(e) => setNombre(e.target.value)} />
            </Field>
            <Field label={t("auth.login.email")}>
              <TextInput
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Field>
            <Field label={t("auth.login.password")} hint="Mínimo 8 caracteres">
              <TextInput
                type="password"
                autoComplete="new-password"
                minLength={8}
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Field>
            <Field label={t("auth.register.roleQuestion")}>
              <Select value={rol} onChange={(e) => setRol(e.target.value as "padre" | "terapeuta")}>
                <option value="padre">{t("role.padre")}</option>
                <option value="terapeuta">{t("role.terapeuta")}</option>
              </Select>
            </Field>
            <Button type="submit" block disabled={enviando}>
              {enviando ? t("common.loading") : t("auth.register.submit")}
            </Button>
          </form>
        </Card>
        <Link to="/login" style={{ textAlign: "center", fontWeight: 700 }}>
          {t("auth.register.toLogin")}
        </Link>
      </Content>
    </AdultScreen>
  );
}
